import {
  Trophy, Award, Medal, Crown, Star, Sparkles,
  BookOpen, GraduationCap, Brain, Lightbulb,
  MessageCircle, Mail, Phone, Headphones,
  Coins, DollarSign, Wallet, Banknote, CreditCard, BadgePercent,
  Zap, Rocket, TrendingUp, Target, Flame,
  Clock, Calendar, Timer,
  Shield, ShieldCheck, Lock, Key,
  Users, User, UserPlus,
  Cpu, Database, Code, Bot, Wand2,
  CheckCircle, Heart, Gift, ThumbsUp, Smile, Globe, Eye, Settings,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const ICONS: Record<string, LucideIcon> = {
  trophy: Trophy, award: Award, medal: Medal, crown: Crown, star: Star, sparkles: Sparkles,
  book: BookOpen, graduation: GraduationCap, brain: Brain, lightbulb: Lightbulb,
  message: MessageCircle, mail: Mail, phone: Phone, headphones: Headphones,
  coins: Coins, dollar: DollarSign, wallet: Wallet, banknote: Banknote, card: CreditCard, percent: BadgePercent,
  zap: Zap, rocket: Rocket, trending: TrendingUp, target: Target, flame: Flame,
  clock: Clock, calendar: Calendar, timer: Timer,
  shield: Shield, 'shield-check': ShieldCheck, lock: Lock, key: Key,
  users: Users, user: User, 'user-plus': UserPlus,
  cpu: Cpu, database: Database, code: Code, bot: Bot, wand: Wand2,
  check: CheckCircle, heart: Heart, gift: Gift, 'thumbs-up': ThumbsUp, smile: Smile, globe: Globe, eye: Eye, settings: Settings,
};

export const ICON_KEYS = Object.keys(ICONS);

export type IconName = keyof typeof ICONS;
